<div class="container-fluid" *ngIf="isCheckDataExists()">
    <fieldset class="border rounded-3 p-1">
        <legend class="float-none w-auto px-1 font-size-13">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.TITLE' | translate}}</legend>
        <ng-container *ngFor="let level of listOfLevelsId;">
        <div class="custom-table">
            <div class="example-container mat-elevation-z8">
              <table mat-table [dataSource]="listOfLaborTypesObjectOnLevelId[level]" class="custom-table full-width table table-bordered no-border">
                <!-- Define columns -->
                
                <ng-container matColumnDef="laborType">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-3"> {{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.LABOR_TYPE' | translate}} </th>
                    <td mat-cell *matCellDef="let element" class="col-sm-3"> {{element.laborType}} </td>
                </ng-container>
                <ng-container matColumnDef="servicingOffice">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-2"> {{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.SERV_OFFICE' | translate}} </th>
                    <td mat-cell  *matCellDef="let element" class="center-align col-sm-2"> {{element.servicingOffice}} </td>
                  </ng-container>
                  <ng-container matColumnDef="standardRate">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.STD_RATE' | translate}}</th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"><span *ngIf="element.laborType !== constants.TOTAL">{{element.standardRate | number : '1.2-2'}} </span>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="baseHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.BASE_HOURS' | translate}}</th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.baseHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="adjustmentHours">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.ADJ_HOURS' | translate}}</th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.adjustmentHours | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="hoursTotal">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.HOURS_TOTAL' | translate}}</th>
                    <td mat-cell class="right-align col-sm-1" *matCellDef="let element"> {{element.hoursTotal | number : '1.2-2'}} </td>
                  </ng-container>
                  <ng-container matColumnDef="otpwr">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-1">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.OT_PWR' | translate}}</th>
                    <td mat-cell  *matCellDef="let element" class="center-align col-sm-1"> {{element.otpwr }} </td>
                  </ng-container>
                  <ng-container matColumnDef="costTotal">
                    <th mat-header-cell *matHeaderCellDef class="col-sm-2">{{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.COST_TOTAL' | translate}}</th>
                    <td mat-cell class="right-align col-sm-2" *matCellDef="let element"> {{element.costTotal | currency:('COMMON_LABELS.CURRENCY' | translate):'symbol-narrow':'':('COMMON_LABELS.LOCALE_CODE' | translate)}} </td>
                  </ng-container>

                  <ng-container matColumnDef="levelDescription">
                    <th mat-header-cell *matHeaderCellDef class="header-1" [attr.colspan]="8"> 
                      {{getLevelName(level)}} 
                    </th>
                  </ng-container>
          
                <!-- Header row -->
                <tr mat-header-row  class="header-row-1" *matHeaderRowDef="['levelDescription']"></tr>
                <tr mat-header-row class="header-row-2" *matHeaderRowDef="displayedColumnsLabor; sticky: true"></tr>
                <!-- Data rows -->
                <tr mat-row *matRowDef="let row; columns: displayedColumnsLabor;">
          
                <!-- Row shown when there is no matching data -->
                <tr class="mat-row" *matNoDataRow>
                  <td class="mat-cell no-data" [attr.colspan]="displayedColumnsLabor.length">{{'COMMON_LABELS.NO_DATA_FOUND' | translate}}</td>
                </tr>
              </table>
            </div>
          </div>
          <br>
        </ng-container>
    </fieldset>
</div>
<div class="container-fluid customizeText" *ngIf="!isCheckDataExists()">
  {{'REVIEW_SOL_LABOR_BY_LEVEL_TAB.LABOR_BY_LEVEL_DATA_NOT_FOUND' | translate}}
  </div>